import {decodePayload} from "@/tools/GenogramTool/PayloadCodec";

export function parseGenogramEmbedBoolean(value) {
	return value === true || value === "true";
}

export function getGenogramEmbedPayload(payloadKey) {
	let payload = null;
	if (!payloadKey || typeof window === "undefined") {
		return payload;
	}

	try {
		let payloadString = window.localStorage.getItem(payloadKey);
		if (!payloadString) {
			return payload;
		}

		payload = decodePayload(payloadString, payloadKey, "genogram");
	} catch (error) {
		console.error("getGenogramEmbedPayload: failed to read payload", error)
		removeGenogramEmbedPayload(payloadKey)
		payload = null;
	}

	return payload;
}

export function consumeGenogramEmbedPayload(payloadKey) {
	let payload = getGenogramEmbedPayload(payloadKey)
	removeGenogramEmbedPayload(payloadKey)
	return payload
}

export function removeGenogramEmbedPayload(payloadKey) {
	if (!payloadKey || typeof window === "undefined") {
		return;
	}
	try {
		window.localStorage.removeItem(payloadKey);
	} catch (error) {
		console.error("removeGenogramEmbedPayload: failed to remove payload", error)
	}
}
